import {changeModal} from "../modules/users/change_modal.js";
import {checkboxPdfRequest} from "../modules/users/checkbox_pdf_request.js";
import {fiscalYearFilter} from "../modules/users/fiscal_year_filter.js";
import {attentionModalTool} from "../modules/exam_results/attention_modal_tool.js";
import {questionSaveTool} from "../modules/exam_results/question_save_tool.js";


function loadModuleByPath() {
    let pathComponent = window.location.pathname;
    if(pathComponent === "/users/index") {
        changeModal();
        checkboxPdfRequest();
        fiscalYearFilter();
    } else if (/^\/exam\/\d{1}$/.test(pathComponent)) {
        attentionModalTool();
        questionSaveTool();
    }

}

function main() {
    loadModuleByPath();
}

let onLoadFunc = function () {
    main();
}

document.addEventListener('turbolinks:load', onLoadFunc);
